
export default {
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
}
